<app-stepper-form
  header="Bulk Appointment of Officeholder"
  formIcon="ic-appoint-officeholder-20"
  [showSteps]="false"
  [currentStepIndex]="currentStepIndex"
  [currentStep]="currentStep"
  [steps]="steps"
  [form]="stepperForm"
  [isLoading]="isLoading()"
  [isInvalid]="areAllRowsHaveErrors"
  (stepIndexChange)="onStepChange($event)"
>
  <div
    class="step-content"
    [formGroup]="stepperForm"
    [class]="{'step-content-error': (currentStep === StepsEnum.Summary && isGridIncludesError)}"
  >
    <app-stepper-form-description
      formKey="484 B2"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.AppointOfficer"
      [hidden]="currentStep !== StepsEnum.AppointOfficer"
    >
      <h1 class="h1-heading">Appoint Officer</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Appointment"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <app-divider margin="0 0 16px 0"/>

      <div>
        <div class="form-group">
          <app-individual-data-form-group
            [useInternationalAddresses]="true"
            [formGroup]="form.controls.newOfficeholder"
            (individualSelected)="onIndividualSelected($event)"
          />
        </div>

        @if (form.touched && form.errors?.['poBoxAddress']) {
          <div class="mb-4">
            <app-validation-error
              [control]="form"
              [customErrors]="addressesCustomErrors"
            />
          </div>
        }

      </div>

      <div class="form-group">
        <app-checkbox-group
          label="Position"
          formControlName="types"
          [options]="positionTypesOptions"
          (changed)="onOfficerTypesChanges($event)"
        />
      </div>

      @if (isDirectorTypeSelected) {
        <div class="form-group">
          <app-din-masked-input
            formControlName="din"
            [shouldCheckDin]="true"
            [fullNameForCheck]="fullNameForDinCheck"
          />
        </div>
      }

      <div class="document-type mb-3">
        <app-radio
          formControlName="documentationType"
          label="Choose the type of document to generate"
          [options]="documentTypeOptions"
        />
      </div>

      <app-disclaimer
        color="light-gray"
        icon="ic-info-circle-20"
      >{{ generateDocumentsInfo }}
      </app-disclaimer>
    </section>

    <section
      class="step-section"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.Summary"
    >
      <h1 class="h1-heading">Change is applied for</h1>

      @if (colDefs.length) {
        <app-list-grid-client-side
          class="bulk-change-grid"
          [rowData]="rows"
          [colDefs]="colDefs"
          [rowSelection]="rowSelection"
          [rowClassRules]="rowClassRules"
          [suppressRowClickSelection]="true"
          [paginationPageSizeSelector]="false"
          [suppressCellFocus]="true"
        />
      }
    </section>
  </div>
</app-stepper-form>
